module.exports = __webpack_public_path__ + "img/Murmeli1.a2197fc7.gif";